// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"aa0b6251","453":"95e8ebf8"}[chunkId] + ".chunk.js";
};